import { TitleListWrap } from './styles'

import type { TitleListInterface } from './interface'


const TitleList = ({ children, style }: TitleListInterface) => (<TitleListWrap style={style}>{children}</TitleListWrap>
)

export default TitleList
